export const BD_STATE_PLURALIZATION_MAPPING = {
  '=0': 'Kein Bundesland',
  '=1': '1 Bundesland',
  other: '# Bundesländer',
};

export const BD_STATE_SUFFIX_PLURALIZATION_MAPPING = {
  '=1': 'Bundesland',
  other: 'Bundesländer',
};

export interface BdState {
  id: number;
  name: string;
}
